import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { RootState } from '../../../redux/store';
import CustomLoader from '../../CustomLoader/CustomLoader';
import UpdatePayment from '../../UpdatePayment/UpdatePayment';
import { subscriptionActions } from '../../../redux/subscription/subscriptionSlice';
import { PlanType } from '../../../utils/enums/plan-type.enum';

function BillingDetails() {
  const clientSecret = useAppSelector((state: RootState) => state.subscription.clientSecret);
  const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`);
  const subscriptionId = useAppSelector((state: RootState) => state.auth.signUpData.plan);
  const dispatch = useAppDispatch();
  const stripeAccountId = useAppSelector((state: RootState) => state.auth.stripeAccountId);
  const plan = useAppSelector((state: RootState) => state.subscription.productDetails);

  useEffect(() => {
    if (subscriptionId) {
      dispatch(subscriptionActions.getProductByIdAsync(subscriptionId));
    }
  }, [dispatch, subscriptionId]);

  const fetchSetupIntentSecret = (customerId: string) => {
    dispatch(subscriptionActions.fetchSetupIntentSecretAsync({ customerId }));
  };

  const fetchPaymentIntentSecret = (customerId: string, amount: number) => {
    dispatch(subscriptionActions.fetchPaymentIntentSecretAsync({ customerId, amount }));
  };

  useEffect(() => {
    if (stripeAccountId && plan) {
      const baseValue = typeof plan.baseValue === 'string' ? parseInt(plan.baseValue, 10) : plan.baseValue;
      if (plan?.name === PlanType.PREMIUM) {
        fetchPaymentIntentSecret(stripeAccountId, baseValue);
      } else {
        fetchSetupIntentSecret(stripeAccountId);
      }
    }
  }, [stripeAccountId, plan]);

  if (!clientSecret) {
    return <CustomLoader />;
  }
  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
      }}
    >
      <ElementsConsumer>
        {({ stripe, elements }) => <UpdatePayment stripe={stripe} elements={elements} />}
      </ElementsConsumer>
    </Elements>
  );
}

export default BillingDetails;
